// extracted by mini-css-extract-plugin
export var closeButton = "_o7-2";
export var closeButtonIcon = "_o7-3";
export var lightboxContent = "_o7-1";
export var lightboxOverlay = "_o7-0";